import { Controller } from "stimulus"

// Generic expand/collapse for tall content (e.g. the /community feature
// matrix). The region target gets an `expanded` class and the button's icon
// swaps. Both of the button's labels are in the page, so a translated copy
// has both translated; this only shows the one that applies.
export default class ExpanderController extends Controller {

  static get targets() {
    return ['region', 'button', 'icon', 'collapsedLabel', 'expandedLabel']
  }

  toggle(e) {
    e.preventDefault()
    const expanded = this.regionTarget.classList.toggle('expanded')
    this.buttonTarget.setAttribute('aria-expanded', expanded)
    this.iconTarget.textContent = expanded ? 'expand_less' : 'expand_more'
    this.collapsedLabelTarget.hidden = expanded
    this.expandedLabelTarget.hidden = !expanded
    if (!expanded) {
      // collapsing from the bottom button can leave the viewport far below
      // the (now much shorter) table — bring the section back into view
      this.element.scrollIntoView({ block: 'nearest' })
    }
  }
}
